import { isPastAwaitingAttendance } from '../cohorts/components/sessions/sessionsHelpers';

/**
 * MED-1360: a participant may reschedule or cancel a booked session only
 * before it ends. A past session that waits for its attendance mark shows
 * "Attendance pending" and no Reschedule or Cancel, because neither can do
 * anything useful for a session that already happened.
 */
export function canChangeBooking(session: {
  status: string;
  scheduled_start: string | null;
  scheduled_end?: string | null;
}): boolean {
  return session.status === 'scheduled' && !isPastAwaitingAttendance(session);
}
